<template>
<div>
    <!-- table -->
    <vue-good-table id="lawMatterBudgetReportBilledAttorneyFeeTable" ref="lawMatterBudgetReportBilledAttorneyFeeTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
                enabled: true,
                externalQuery: searchTerm
              }" :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'dailyworkDate'" class="text-nowrap">
                {{ $t('lawMatterBudgetReport.date') }}
            </span>
            <span v-else-if="props.column.field === 'code'" class="text-nowrap">
                {{ $t('lawMatterBudgetReport.code') }}
            </span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('lawMatterBudgetReport.description') }}
            </span>
            <span v-else-if="props.column.field === 'currencyCode'" class="text-nowrap">
                {{ $t('lawMatterBudgetReport.currency_code') }}
            </span>
            <span v-else-if="props.column.field === 'price'" class="text-nowrap">
                {{ $t('lawMatterBudgetReport.amount') }}
            </span>
            <span v-else-if="props.column.field === 'debitNo'" class="text-nowrap">
                {{ $t('lawMatterBudgetReport.debit_no') }}
            </span>
        </template>
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'price'">
                <span>
                    {{ $formatMoney(props.row.price) }}
                </span>
            </span>
        </template>
    </vue-good-table>
</div>
</template>

    
<script>
export default {
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('lawMatterBudgetReport.date'),
                    field: `dailyworkDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('lawMatterBudgetReport.code'),
                    field: `code`,
                },
                {
                    label: this.$t('lawMatterBudgetReport.description'),
                    field: `description`,
                },
                {
                    label: this.$t('lawMatterBudgetReport.currency_code'),
                    field: `currencyCode`,
                },
                {
                    label: this.$t('lawMatterBudgetReport.amount'),
                    field: `price`,
                },
                {
                    label: this.$t('lawMatterBudgetReport.debit_no'),
                    field: `debitNo`,
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        // this.getlawMatterBudgetReportBilledAttorneyFeeList()
    },
    methods: {
        setValues(values) {
            values.forEach(element => {
                this.rows.push(element)
            })
        }
    },
}
</script>

    
<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
